export default __webpack_public_path__ + "static/media/lg.3d242aa6.png";